import { useMemo } from 'react';
import { UploadSummary } from '../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { TooltipGenericInfo } from '../../../commonUI/tooltips/TooltipGenericInfo';
type Props = {
  uploadSummary: UploadSummary;
};

/**
 * Tooltip component that displays upload summary information
 * Includes customer details, upload status and progress
 */
export const TooltipUploadSummary = ({ uploadSummary }: Props) => {
  const { t } = useTranslation();

  // Extract relevant fields from upload summary and format them for the tooltip
  const items = useMemo(() => {
    const {
      customerName,
      customerID,
      overallPercentUploaded,
      overallStatus,
      latestCollectionDate,
      uploads,
    } = uploadSummary;

    return [
      {
        label: t('Customer Name'),
        value: customerName,
      },
      {
        label: t('Customer ID'),
        value: customerID,
      },
      {
        label: t('Upload Progress'),
        value: `${overallPercentUploaded}%`,
      },
      {
        label: t('Status'),
        value: overallStatus,
      },
      {
        label: t('Latest Collection Date'),
        value: latestCollectionDate,
      },
      {
        label: t('Total Uploads'),
        value: String(uploads.length),
        showCopyButton: false,
      },
    ];
  }, [uploadSummary, t]);

  return <TooltipGenericInfo title={t('Upload Summary')} items={items} />;
};
